export const environment = {
  production: false,
  nodeUrl: 'https://dev-api.ziputils.com/graphql',
  angularUrl: 'https://dev.ziputils.com',
};
